/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * FR API Documentation
 * OpenAPI spec version: 1
 */

export type PublicInspectionDocumentFieldItem = typeof PublicInspectionDocumentFieldItem[keyof typeof PublicInspectionDocumentFieldItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicInspectionDocumentFieldItem = {
  agencies: 'agencies',
  agency_letters: 'agency_letters',
  agency_names: 'agency_names',
  docket_numbers: 'docket_numbers',
  document_number: 'document_number',
  editorial_note: 'editorial_note',
  excerpts: 'excerpts',
  filed_at: 'filed_at',
  filing_type: 'filing_type',
  html_url: 'html_url',
  json_url: 'json_url',
  last_public_inspection_issue: 'last_public_inspection_issue',
  num_pages: 'num_pages',
  page_views: 'page_views',
  pdf_file_name: 'pdf_file_name',
  pdf_file_size: 'pdf_file_size',
  pdf_updated_at: 'pdf_updated_at',
  pdf_url: 'pdf_url',
  publication_date: 'publication_date',
  raw_text_url: 'raw_text_url',
  subject_1: 'subject_1',
  subject_2: 'subject_2',
  subject_3: 'subject_3',
  title: 'title',
  toc_doc: 'toc_doc',
  toc_subject: 'toc_subject',
  type: 'type',
} as const;
